<app-spinner-overlay [showSpinner]="loading"></app-spinner-overlay>
<wl-card heading="Error logs ({{totalCount}})" subheading1="{{subheading1}}" subheading2="{{subheading2}}">

  <!-- <input class="date" type="month" id="start" name="start" min="2022-01" [max]="maxDate" [(ngModel)]="formatFilterTableDate"    #date1
  >

  <button class="ml-10px mybutton bb" (click)="submitDates()">Submit</button> -->

  <!-- <wl-date-input (dateRangeSelected)="onDateRangeSelected($event)"></wl-date-input> -->
  <!-- <span *ngIf="showSelectedDate" class="datetext">&nbsp;&nbsp;{{selectedDate}}&nbsp;&nbsp;<img src="../../../assets/fontawesome-web/svgs/regular/rectangle-xmark.svg" class="h-15px" (click)="closeButtonClick()">
  </span> -->

  <!-- <div>
    <mat-form-field class="w-full">
      <input type="text" matInput placeholder="{{searchHolder}}" (input)="onSearchClick($event)" [formControl]="search"><img
      class="ml-neg30px-important" src="../../../assets/svg/search.svg">
    </mat-form-field>
  </div> -->

  <!-- <p *ngIf="noUserFound" class="m-100px text-center font-size-15em">{{noUserFound}}</p> -->
  <div>
    <label for="start-date">From</label>
    <input type="date" class="dateStyle" id="start-date" [(ngModel)]="startDateNew" name="startDate">
  
    <label for="end-date">To</label>
    <input type="date" class="dateStyle" id="end-date" [(ngModel)]="endDateNew" name="endDate">
  
    <!-- <label for="dropdown">Dropdown:</label>
    <select id="dropdown" [(ngModel)]="dropdownSelection" name="dropdown">
      <option *ngFor="let option of dropdownOptions" [value]="option">{{ option }}</option>
    </select> -->
<!-- <span> -->
   
      <mat-select  placeholder="Select Error Level Filter"  [(ngModel)]="dropdownSelection" class="w-19rem mt-neg1rem text-left" >
        <mat-option *ngFor="let option of dropdownOptions" [value]="option.value">{{ option.type }}</mat-option>
      </mat-select>
  <!-- </span> -->
    <button class="ml-10px mybutton" (click)="onSubmit()">Submit</button>
    <button  class="ml-10px mybutton" (click)="downloadFile()">Download 
      Report</button>
     
      <div class="searchAlign">
        <mat-form-field  class="errorlogStyle">
          <input type="text" matInput placeholder="{{searchHolder}}" (input)="onSearchClick($event)" [formControl]="search"><img
            class="ml-neg30px-important" src="../../../assets/svg/search.svg">
        </mat-form-field>
      </div>
      <p *ngIf="noUserFound" class="m-100px text-center font-size-15em">{{noUserFound}}</p>
    <br>
  </div>
<!-- <span>
  <button  class="ml-10px mybutton" (click)="downloadFile()">Download Report</button>
</span> -->

  <div  child-container class="table-responsive" *ngIf="showTable">
    <table class="table table-hover">
      <thead>
        <tr>
          <th>Sr. No.</th>
          <th>Error Code<br>
          <th  class="w-22pct">Error Message <br>
          <th>Error location<br>
          <th>Function/API Name<br>
          <th>Timestamp <br>
          <th>Level <br>
        </tr>
      </thead>

      <tbody>
        <tr  *ngFor="let user of allUsers;let i = index;" >
          <td class="vertical-align-middle">
            <p>{{10 *(pageId-1)+i+1}}</p>   
          </td>
          <td class="vertical-align-middle">
            <p>{{user?.error_code? user.error_code: 'Error code not available'  }}</p>
          </td>
          <td class="vertical-align-middle">
            <p>{{user && user.error_message && user.error_message.errormsg? user.error_message.errormsg : "Error message not available"}}</p>
            </td>
          <td class="vertical-align-middle">
            <p>{{user && user.error_message && user.error_message.errorloc? user.error_message.errorloc : "Error location not avialable " }}</p>
          </td>
          <td class="vertical-align-middle">
            <p >
              {{user && user.function_name?  user.function_name : "Function name not found"
              }}
            </p>
          </td>
          <td class="vertical-align-middle">
            <p >
              {{user.timestamp | date: 'dd-MM-yyyy hh:mm:ss a'}}              
            </p>
          </td>
          <td class="vertical-align-middle">
            <p >
              {{user && user.level? user.level :"level not found"}}              
            </p>
          </td>
        </tr>
      </tbody>

    </table>
  </div>

  <nav class="flex-center" *ngIf="totalPage>1 && !this.noUserFound" aria-label="Page navigation example">
    <ul class="pagination">
      <!-- limit - 10 -->
      <li *ngIf="page>3"><a (click)="getAllUsersPage('',roleId,offset - 1,10,page - 1)">Previous</a></li>
      <li *ngIf="page>2"><a (click)="getAllUsersPage('',roleId,offset - 2,10,page - 2)">{{page - 2}}</a></li>
      <li *ngIf="page>1"><a (click)="getAllUsersPage('',roleId,offset - 1,10,page - 1)">{{page - 1}}</a></li>
      <li class="page-item active"><a (click)="getAllUsersPage('',roleId,offset,10,page)">{{page}}</a></li>
      <li *ngIf="page<totalPage"><a (click)="getAllUsersPage('',roleId,offset + 1,10,page + 1)">{{page + 1}}</a></li>
      <li *ngIf="page+1<totalPage"><a (click)="getAllUsersPage('',roleId,offset + 2,10,page + 2)">{{page + 2}}</a></li>
      <li *ngIf="page<totalPage"><a (click)="getAllUsersPage('',roleId,offset + 1,10,page + 1)">Next</a></li>
    </ul>
  </nav>



</wl-card>
